import React, { useEffect, useRef, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useMutation, gql } from '@apollo/client'
import { saveCustomerSupportPhone } from '../../../apollo'
import { Box, Typography, Input, Button, Alert } from '@mui/material'
import useStyles from '../styles'
import useGlobalStyles from '../../../utils/globalStyles'

const SAVE_CUSTOMER_SUPPORT_PHONE = gql`
  ${saveCustomerSupportPhone}
`

function CustomerSupportPhoneConfiguration(props) {
  const { t, supportChatNumber = '' } = props
  const formRef = useRef()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const [mutate, { loading }] = useMutation(SAVE_CUSTOMER_SUPPORT_PHONE, {
    onCompleted: data => {
      setErrorMessage('')
      setSuccessMessage(
        data?.saveCustomerSupportPhone?.supportChatNumber
          ? 'Configuration saved successfully!'
          : 'Saved'
      )
    },
    onError: error => {
      setSuccessMessage('')
      setErrorMessage(
        error?.message || 'An error occurred while saving configuration.'
      )
    }
  })

  useEffect(() => {
    if (!successMessage && !errorMessage) return
    const timeoutId = setTimeout(() => {
      setSuccessMessage('')
      setErrorMessage('')
    }, 3000)
    return () => clearTimeout(timeoutId)
  }, [successMessage, errorMessage])

  const onSave = e => {
    e.preventDefault()
    const value = formRef.current?.['input-support-chat-number']?.value?.trim()
    if (!value || loading) return
    mutate({
      variables: {
        supportChatNumber: value
      }
    })
  }

  return (
    <Box container className={classes.container}>
      <Box className={classes.flexRow}>
        <Box item className={classes.heading}>
          <Typography variant="h6" className={classes.text}>
            {t('Customer Support Phone')}
          </Typography>
        </Box>
      </Box>

      <Box className={classes.form}>
        <form ref={formRef}>
          <Box>
            <Typography className={classes.labelText}>
              {t('Support Chat Number')}
            </Typography>
            <Input
              style={{ marginTop: -1 }}
              id="input-support-chat-number"
              name="input-support-chat-number"
              placeholder={t('Enter support phone number')}
              type="text"
              defaultValue={supportChatNumber}
              disableUnderline
              className={globalClasses.input}
            />
          </Box>
          <Box mt={2}>
            <Button
              className={globalClasses.button}
              disabled={loading}
              onClick={onSave}>
              {t('Save')}
            </Button>
          </Box>
          <Box mt={2}>
            {successMessage && (
              <Alert
                className={globalClasses.alertSuccess}
                variant="filled"
                severity="success">
                {successMessage}
              </Alert>
            )}
            {errorMessage && (
              <Alert
                className={globalClasses.alertError}
                variant="filled"
                severity="error">
                {errorMessage}
              </Alert>
            )}
          </Box>
        </form>
      </Box>
    </Box>
  )
}

export default withTranslation()(CustomerSupportPhoneConfiguration)
